import { Tooltip } from '@material-ui/core';
import $ from 'jquery';
import { getTooltips } from '../modules/generator/generator-utils';
import { debounce } from "../utils/functions";

const generator = $('.id-generator-app');
const $window = $(window);
const swipeTreshold = {x: 50, y: 50};
const maxDeviceWidth = 575;
const data = {
    lastFocus: 0,
    startMousePos: { x: -1, y: -1 },
    endMousePos: { x: -1, y: -1 },
};

$(function() {
    generator.on('DOMSubtreeModified', function() {
        if ($window.width() <= maxDeviceWidth) {
            bindItems();
            reloadSwiper();
        }
    });
    $window.on('resize', debounce(reloadSwiper, true));
    if ($window.width() <= maxDeviceWidth) {
        bindItems();
        reloadSwiper();
    }
});

function bindItems(){
    const container = $('.generator__stepper');  
    
    container.off('touchstart').off('touchend');   
    container.on('touchstart', function (event) {
        onTouchStart(event);
    });
    container.on('touchend', function (event) {
        onTouchEnd(event);
    });
}

function reloadSwiper(){
    let numberDone = $('.stepper__item--done').length;
    
    setSwiper(numberDone);
}

function setSwiper(focusItem){
    const itemsBlock = $('.stepper__items');
    const container = $('.stepper__container');
    let containerWidth = container.width();
    let toShowItemsWidth = 0;
    let toSwipe = 0;
    data.lastFocus = focusItem;
    
    const stepperItems = itemsBlock.find('.stepper__item');
    let cnt = 0;
    stepperItems.each(function(){
        const thisEl = $(this);
        
        if (cnt < focusItem - 1 && cnt < stepperItems.length - 3){
            toSwipe -= thisEl.innerWidth();
        }else if (cnt <= focusItem + 1 || cnt < 3){
            toShowItemsWidth += thisEl.innerWidth();
        }

        cnt++;
    });
    
    let itemsPadding = containerWidth - toShowItemsWidth;
    toSwipe += itemsPadding / 2;

    itemsBlock.css('left', toSwipe);
}

function onTouchStart(event) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.startMousePos.x = touch.pageX;
    data.startMousePos.y = touch.pageY;
}

function onTouchEnd(event) {
    const stepperItems = $('.stepper__item');
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.endMousePos.x = touch.pageX;
    data.endMousePos.y = touch.pageY;
    
    const mousePosDiff = {
        x: data.startMousePos.x - data.endMousePos.x,
        y: data.startMousePos.y - data.endMousePos.y,
    };
    
    data.startMousePos = { x: -1, y: -1 };
    data.endMousePos = { x: -1, y: -1 };
    
    if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
        if (mousePosDiff.x > 0) {
            let skip = 1;
            if (data.lastFocus == 0){
                skip = 2;
            }
            setSwiper(Math.min(data.lastFocus + skip, stepperItems.length - 1));
        } else {
            let skip = 1;
            if (data.lastFocus == stepperItems.length - 1){
                skip = 2;
            }
            setSwiper(Math.max(data.lastFocus - skip , 0));
        }
    }
}
